// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-initial {
  display: block;
  box-sizing: border-box;
  width: 100%;
}
.group-initial .motes-input {
  padding: 10px;
  text-align: center;
  font-family: "Century Gothic", Gothic, sans-serif;
  font-size: 15px;
  margin-bottom: 0;
}
.group-initial .motes-input[type=number] {
  appearance: textfield;
}
.group-initial input::-webkit-outer-spin-button,
.group-initial input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.group-initial aside {
  min-height: 1em;
}
.group-initial aside p {
  font-size: 0.8em;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-initial/group-initial.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,sBAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,gBAAA;AACR;AAGI;EACI,qBAAA;AADR;AAII;;EAEI,wBAAA;EACA,SAAA;AAFR;AAKI;EACI,eAAA;AAHR;AAKQ;EACI,gBAAA;EACA,SAAA;AAHZ","sourcesContent":[".group-initial {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n\n    .motes-input {\n        padding: 10px;\n        text-align: center;\n        font-family: \"Century Gothic\", Gothic, sans-serif;\n        font-size: 15px;\n        margin-bottom: 0;\n    }\n\n    // Hide arrows from number input\n    .motes-input[type=\"number\"] {\n        appearance: textfield;\n    }\n\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    aside {\n        min-height: 1em;\n\n        p {\n            font-size: 0.8em;\n            margin: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
